/*
import { useSelector, useDispatch } from 'react-redux';
import { updateMessage,updateMessage2} from '../store/slice';

const message = useSelector((state:any) => state.message);
const dispatch = useDispatch();

dispatch(updateMessage("Hi.Mani.Saro.."));
console.log("message:",message);
*/
import { createSlice } from '@reduxjs/toolkit';

export const login = createSlice({
  name: 'login',
  initialState: {
    loginCred: {},
    login: {},
    importData: [],
    contactUploadError: [],
    uploadFileURL: {},
    planInfo: {},
    featureInfo: [],
    numbers: [],
    PaymentFormat: [],
    paymentCardDetails: [],
    paymentStep1Resp: [],
    paymentStep2Resp: [],
    selectedColumn: [],
    userType: "",
    userHourAttend: [],
    getRingtypeval: [],
    documentInfo: [],
    didCountryCode: {},
    didCityCode: '',
    numberTypeValue: [],
    getSkuIdUK: [],
    getAvalIdUK: [],
    smsValue: {},
    addonGetList : [],
    userExtenInfo:{},
  },
  reducers: {
    updateLogin: (state, actions) => {
      state.login = actions.payload;
    },
    updateLoginCred: (state, actions) => {
      state.loginCred = actions.payload;
    },
    updateImportData: (state, actions) => {
      state.importData = actions.payload;
    },
    updateContactUploadError: (state, actions) => {
      state.contactUploadError = actions.payload;
    },
    uploadFileURLget: (state, actions) => {
      state.uploadFileURL = actions.payload;
    },
    updatePlanInfo: (state, actions) => {
      state.planInfo = actions.payload;
    },
    updateFeatureInfo: (state, actions) => {
      state.featureInfo = actions.payload;
    },
    purchaseSelectedNumbers: (state, actions) => {
      state.numbers = actions.payload;
    },
    numbersPaymentFormat: (state, actions) => {
      state.PaymentFormat = actions.payload;
    },
    paymentserviceNumbers: (state, actions) => {
      state.paymentCardDetails = actions.payload;
    },
    paymentserviceNumbersStep1Result: (state, actions) => {
      state.paymentStep1Resp = actions.payload;
    },
    paymentserviceNumbersStep2Result: (state, actions) => {
      state.paymentStep2Resp = actions.payload;
    },
    setLoginReset: (state, actions) => {
      state.login = actions.payload;
    },
    updateSelectColumn: (state, actions) => {
      state.selectedColumn = actions.payload;
    },
    updateUserType: (state, actions) => {
      state.userType = actions.payload;
    },
    setUserHourAttend: (state, actions) => {
      state.userHourAttend = actions.payload;
    },
    setRingTypeval: (state, actions) => {
      state.getRingtypeval = actions.payload;
    },
    setDocumentInfo: (state, actions) => {
      state.documentInfo = actions.payload;
    },
    setDidCountryCode: (state, actions) => {
      state.didCountryCode = actions.payload;
    },
    setDidCityCode: (state, actions) => {
      state.didCityCode = actions.payload;
    },
    setNumberTypeValue: (state, actions) => {
      state.numberTypeValue = actions.payload;
    },
    setSkuIdUK: (state, actions) => {
      state.getSkuIdUK = actions.payload;
    },
    setAvalIdUK: (state, actions) => {
      state.getAvalIdUK = actions.payload;
    },
    setSmsValue: (state, actions) => {
      state.smsValue = actions.payload;
    },
    setAddonGetList: (state, actions) => {
      state.addonGetList = actions.payload;

    },
    setUserExtenInfo: (state, actions) => {
      state.userExtenInfo = actions.payload;

    },
  }
});

export const {
  updateLogin,
  updateLoginCred,
  updateImportData,
  updateContactUploadError,
  uploadFileURLget,
  updatePlanInfo,
  updateFeatureInfo,
  purchaseSelectedNumbers,
  numbersPaymentFormat,
  paymentserviceNumbers,
  paymentserviceNumbersStep1Result,
  paymentserviceNumbersStep2Result,
  setLoginReset,
  updateSelectColumn,
  updateUserType,
  setUserHourAttend,
  setRingTypeval,
  setDocumentInfo,
  setDidCountryCode,
  setDidCityCode,
  setNumberTypeValue,
  setSkuIdUK,
  setAvalIdUK,
  setSmsValue,
  setAddonGetList,
  setUserExtenInfo
} = login.actions

export default login.reducer;
